/* eslint-disable no-unused-vars */
import { useState } from "react";

function SpotElements({
  coordsSelectedImg,
  selectedTrans,
  showVO,
  showDue,
  showHideSlide,
  imageHeight,
  imageWidth,
  originalHeight,
  originalWidth,
  deleteZone,
  handleMouseDown,
  isLayered,
}) {

  const toRem = parseFloat(getComputedStyle(document.documentElement).fontSize);
  // console.log('toRem : ', toRem);
  const renderSpots = () => {
    console.log(`inside spot w: ${imageWidth} h: ${imageHeight} ow: ${originalWidth} oh: ${originalHeight}`)
    if (coordsSelectedImg?.page_status === "done" && (coordsSelectedImg?.trans_status === "" || coordsSelectedImg?.trans_status === "done")) {
      return coordsSelectedImg?.sous_images?.map((e, i) => (
        <div id={`spote-${i}`} className='spote' key={i} style={{
          position: 'absolute',
          top: `${((imageHeight * e.coord.Y) / originalHeight) / toRem}rem`,
          left: `${((imageWidth * e.coord.X) / originalWidth) / toRem}rem`,
          width: `${((imageWidth * e.coord.W) / originalWidth) / toRem}rem`,
          height: `${((imageHeight * e.coord.H) / originalHeight) / toRem}rem`,
          border: `1.5px solid red`,
        }}>
          {!isLayered && <span id={e._id} className='delete_zone' onClick={() => deleteZone(e, i)}>X</span>}
          <span id={`ref-${e._id}`} className='ref_spot'>{e?.name_sous_image?.split('.')[0]?.replace('_', '-')}</span>
        </div>
      ));
    } else if (coordsSelectedImg?.trans_status === "trans" && selectedTrans?.sous_images && showVO === false) {
      return selectedTrans?.sous_images?.map((e, i) => (
        <div
          id={`spote-${i}`}
          className="spote"
          key={i}
          style={{
            cursor: 'move',
            position: 'absolute',
            top: `${((imageHeight * e.coord.Y) / originalHeight) / toRem}rem`,
            left: `${((imageWidth * e.coord.X) / originalWidth) / toRem}rem`,
            width: `${((imageWidth * e.coord.W) / originalWidth) / toRem}rem`,
            height: `${((imageHeight * e.coord.H) / originalHeight) / toRem}rem`,
            border: `1.5px solid ${e?.traduction_validee ? 'green' : 'red'}`,
            transform: `rotate(${e.coord.R}deg)`,
            padding: `${(imageWidth * 0.1) / originalWidth}rem`, // adjusted padding
            overflow: 'visible',
          }}
          onMouseDown={(event) => handleMouseDown(event, i, 'drag')}
        >
          <span
            className="ref_spot"
            style={e?.traduction_validee ? { backgroundColor: 'green' } : {}}
          >
            {e?.name_sous_image?.split('.')[0]?.replace('_', '-')}
          </span>

          <svg
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid meet"
            style={{
              width: '100%',
              height: '100%',
              overflow: 'visible',
            }}
          >
            {/* Outline Text */}
            {e?.stroke_applied === true && <text
              x="50"
              y="50"
              textAnchor="middle"
              dominantBaseline="middle"
              fill="none"
              stroke={`rgb(${e?.stroke_color})`}
              strokeWidth={e.stroke_blur}
              style={{
                fontFamily: e?.fontName || 'Wildjess',
                fontSize: `${e?.size}em`,
                fontWeight: e?.fontWeight,
                fontStyle: e?.fontStyle,
              }}
            >
              {e?.text_translated?.split('\n').map((line, idx, arr) => (
                <tspan
                  key={`outline-${idx}`}
                  x="50"
                  dy={idx === 0 ? `${-(arr.length - 1) * (+e?.stroke_opacity) / 2}em` : `${(+e?.stroke_opacity)}em`}
                >
                  {line}
                </tspan>
              ))}
            </text>}

            {/* Fill Text */}
            <text
              x="50"
              y="50"
              textAnchor="middle"
              dominantBaseline="middle"
              fill={e?.color || 'black'}
              stroke="none"
              style={{
                fontFamily: e?.fontName || 'Wildjess',
                fontSize: `${e?.size}em`,
                fontWeight: e?.fontWeight,
                fontStyle: e?.fontStyle,
              }}
            >
              {e?.text_translated?.split('\n').map((line, idx, arr) => (
                <tspan
                  key={`fill-${idx}`}
                  x="50"
                  dy={idx === 0 ? `${-(arr.length - 1) * (+e?.stroke_opacity) / 2}em` : `${(+e?.stroke_opacity)}em`}
                >
                  {line}
                </tspan>
              ))}
            </text>
          </svg>

          <div
            id={`resizer-${i}`}
            className="resizer"
            style={e?.traduction_validee ? { backgroundColor: 'green' } : {}}
            onMouseDown={(event) => handleMouseDown(event, i, 'resize')}
          ></div>

          <div
            id={`rotation-${i}`}
            className="rotation"
            style={e?.traduction_validee ? { backgroundColor: 'green' } : {}}
            onMouseDown={(event) => handleMouseDown(event, i, 'rotate')}
          ></div>
        </div>

      ));
    } else if (coordsSelectedImg?.trans_status === "trans" && showVO === true) {
      return coordsSelectedImg?.sous_images?.map((e, i) => (
        <div id={`spote-${i}`} className='spote' key={i} style={{
          position: 'absolute',
          top: `${((imageHeight * e.coord.Y) / originalHeight) / toRem}rem`,
          left: `${((imageWidth * e.coord.X) / originalWidth) / toRem}rem`,
          width: `${((imageWidth * e.coord.W) / originalWidth) / toRem}rem`,
          height: `${((imageHeight * e.coord.H) / originalHeight) / toRem}rem`,
          border: `1.5px solid red`,
        }}>
          <span className='ref_spot'>{e?.name_sous_image?.split('.')[0]?.replace('_', '-')}</span>
        </div>
      ));
    }
    return null;
  };

  return (
    <div>
      {renderSpots()}
    </div>
  );
}

export default SpotElements;
